<template lang="pug">
	.products-templates-list.flex-col.space.tb-padding
		ListView.full-width(
			ref="templatesListView",
			initialView="table",
			:getTotal="(r) => r.TotalNumberOfRecords",
			:getItems="(r) => prepareData(r.Results)",
			:getData="getData",
			:columns="columns",,
			:filterRow="true",
			:remoteSorting="true",
			:hideViewsSelection="true",
			:autoFit="true",
			:heightDelta="30"
		)
			template(slot="left-actions")
				.flex-row.space-between.space-large.margin-bottom.align-center
					.flex-row.space-large.align-center
						.font-large {{$tCaption('Creative Templates')}}
						DxButton(
							icon="fas fa-scroll",
							:text="$tCaption('Create Template')"
							@click="showCreateTemplatePopup()"
						)

			template(v-slot:displayValue="{ data }")
				.flex-row.space-medium
					template(v-if="data.ImageUrl")
						img.thumb-image(:src="data.ImageUrl")
					template(v-else)
						.thumb-image
					.flex-col.space.grey.creative-template.flex-1.wrap
						.flex-row.space.align-center
							.play-button-handler.flex-col.center.align-center
								a.play-button(
									@click="playAudio(data)",
									:class="{ disabled: !data.FinalAudioUrl }"
								)
									fas(:icon="isAudioLoading === data.Oid ? 'spinner' : (isPlaying === data.Oid ? 'stop' : 'play')", :spin="isAudioLoading === data.Oid")
							.flex-1.flex-row
								a.flex-row.space.align-center.font-big(@click="e => editTemplate(data, e.ctrlKey)")
									span {{data.RootCreativeName || data.Name}}
									i.fas.fa-pen-square
						.description.font-small {{data.Description}}
		Popup(
			:popupVisible="templatePopupVisible",
			:title="$tCaption('Create template')"
			:width="720", :height="720",
			:closeOnOutsideClick="false",
			@hiding="hidingTemplatePopupVisible()"
		)
			CreativeDetail(
				:editingCreative="newTemplate",
				:isLoading="isLoading",
				:newCreateTemplate="true",
			)
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="hidingTemplatePopupVisible")
				DxButton(:text="$tCaption('Create', '@actions')", type="success", @click="createTemplate")
</template>

<script>
	import Popup from 'app-core/Popup.vue';
	import ListView from 'app-core/ListView.vue';
	import CreativeDetail from 'view/creative/CreativeDetail.vue';
	import DxButton from 'devextreme-vue/button';

	export default {
		translationCategory: 'creatives.Templates.List',
		name: 'products-creatives-templates-list',
		components: {
			Popup,
			ListView,
			CreativeDetail,
			DxButton,
		},
		data() {
			return {
				columns: [{ dataField: 'Name', cellTemplate: 'displayValue' }],
				isLoading: 0,
				isAudioLoading: false,
				isPlaying: false,
				player: null,
				templatePopupVisible: false,
				defaultTemplate: {
					IsProduct: true,
					IsTemplate: true,
					Name: 'New creative template',
					JsonConfig: {
						templateFields: []
					},
					Description: null,
					ImageUrl: null,
					LanguageCode: null,
					Price: null,
					CurrencyCode: null,
				},
				newTemplate: null,
			};
		},
		methods: {
			getData(pageIndex, limit, opts) {
				this.isLoading++;
				return this.$Data
					.getCreativeTemplates(pageIndex, limit, opts)
					.then((r) => {
						return r;
					})
					.finally(() => this.isLoading--);
			},
			prepareData(data) {
				return data.map(f => ({ ...f }));
			},
			createTemplate(e) {
				if (__DEBUG__)
					console.debug('Create template', { e });
				if (e?.validationGroup && !e.validationGroup.validate().isValid) {
					return;
				}
				this.$Data
					.createUpdateCreative(this.newTemplate)
					.then(() => {
						this.hidingTemplatePopupVisible();
						this.$refs.templatesListView?.reload();
					});
			},
			editTemplate(template, separateWindow) {
				let route = { path: `/creative/Detail/${template.Oid}` };
				if (separateWindow) {
					let routeData = this.$router.resolve(route);
					window.open(routeData.href, '_blank');
				} else {
					this.$router.push(route);
				}
			},
			playAudio(template) {
				if (this.isAudioLoading) return;

				let hasBeenPlaying = this.isPlaying;
				this.stopAudio();

				if (hasBeenPlaying) return;

				this.player = new Audio();
				try {
					this.player.src = `${template.FinalAudioUrl}`;
					this.player.play();
					this.isPlaying = template.Oid;
					this.isAudioLoading = template.Oid;
					this.player.addEventListener('canplaythrough', () => this.isAudioLoading = null, false);
					this.player.addEventListener('ended', () => this.isPlaying = null, false);
				} catch {
					this.isAudioLoading = null;
					this.isPlaying = null;
				}
			},
			stopAudio() {
				if (this.player) {
					this.player.pause();
				}
				this.isPlaying = null;
			},
			showCreateTemplatePopup() {
				this.newTemplate = { ...this.defaultTemplate };
				this.$nextTick(()=> {
					this.templatePopupVisible = true;
				});
			},
			hidingTemplatePopupVisible() {
				this.templatePopupVisible = false;
				this.newTemplate = null;
			},
		}
	};
</script>

<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.products-templates-list {
		.thumb-image {
			width: 100px;
			height: 100px;
			border-radius: 8px;
			background: rgba(0, 0, 0, 0.03);
			overflow: hidden;
			border: 1px solid rgba(0, 0, 0, 0.01);
			box-shadow: 0 1px 3px rgb(0 0 0 / 5%);
		}

		.play-button {
			color: #777;
			padding: 4px;
			transform: scale(1);
			transition: 0.2s;

			&.disabled {
				opacity: 0.3;
				pointer-events: none;
			}

			&:hover:not(.disabled) {
				color: $base-accent;
				transform: scale(1.3);
			}
		}

		.center-fixed {
			position: absolute;
			height: auto;
			width: 100%;
			left: 0px;
			top: 50%;
			transform: translateY(-50%);
		}

		.play-button-handler {
			border-radius: 100px;
			border: 1px solid #ededed;
			min-width: 30px;
			min-height: 30px;
			padding-top: 2px;

			svg[data-icon=play] {
				padding-left: 2px;
			}
		}

		.delete-button {
			color: #d90000;
		}

		.add-creative-button {
			width: 90px;
			height: 90px;
			background: rgb(239, 241, 243);
			border-radius: 4px;
			color: #555;
			cursor: pointer;
			transition: 0.3s;

			.text {
				font-size: 10px;
			}

			&:hover {
				background: $base-accent;
				color: $base-bg;
			}
		}

		td.dx-last-data-cell {
			background: #f7f7f7;
		}

		td.dx-last-data-cell {
			border-bottom: none;
		}

		.free-price {
			right: 0px;
			top: 0px;
			padding: 0px 5px;
			background: rgb(255 58 54);
			border-radius: 4px;
			font-size: 10px;
			line-height: 2;
			background: linear-gradient(90deg, rgb(255 58 54) 0%, rgba(255,119,0,1) 100%);
			color: #fff;
			height: 20px;
		}
	}
</style>
